export enum ScheduledMediaChatType {
    Disabled = "disabled",
    Public = "public",
}

export interface CncProps {
    config: any;
    isScheduledModeration?: boolean;
    moderationStartTime?: number;
    moderationEndTime?: number;
    isScheduledGroupChat?: boolean;
    groupChatStartTime?: number;
    groupChatEndTime?: number;
    isScheduledMediaChat?: boolean;
    scheduledMediaChatConfig?: {
        // Session start time with offset (UNIX timestamp in seconds)
        startTime: number;
        // Session end time with offset (UNIX timestamp in seconds)
        endTime: number;
        // Chat type before the session starts
        preScheduleChatType: ScheduledMediaChatType;
        // Chat type during the session
        duringScheduleChatType: ScheduledMediaChatType;
        // Chat type after the session ends
        postScheduleChatType: ScheduledMediaChatType;
    };

    // if enabled, will console log unisphere logs.
    verbose?: boolean;
    // if provided will enable cnc in unisphere mode (unisphere mode is when the CNC works with an event server that will send and receive events to orchestrate cnc to newrow comms when both are hosted in a hosting application)
    serverUrl?: string;
    // an interface for sending override commands to the cnc through config (dev mode mostly)
    devOverrides?: string;
}

export interface CncReactionsMobileProps {
    isRoomEntry?: boolean;
}
